import CustomerIcon from '@material-ui/icons/ContactMail';
import CustomerList from './customerList.js';
import CustomerCreate from './customerCreate.js';

export default {
    create: CustomerCreate,
    icon: CustomerIcon,
    list: CustomerList,
};